import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box } from '@mui/material';
import SuperCapstoneHeader from './SuperCapstoneHeader';
import CapstoneSteps from './CapstoneSteps';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Index = () => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [capstoneEditData, setCapStoneEditData] = useState(null);

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label='opportunity'
            variant='scrollable'
            scrollButtons='auto'>
            <Tab
              label='All Super Capstones'
              {...a11yProps(0)}
              onClick={() => setCapStoneEditData(null)}
            />
            <Tab label='Create New Super Capstone' {...a11yProps(1)} />
          </Tabs>
        </Box>

        <TabPanel value={value} index={0}>
          <SuperCapstoneHeader
            setCapStoneEditData={setCapStoneEditData}
            setValue={setValue}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <CapstoneSteps
            capstoneEditData={capstoneEditData}
            setCapStoneEditData={setCapStoneEditData}
            setValue={setValue}
          />
        </TabPanel>
      </Box>
    </>
  );
};

export default Index;
